import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import classNames from 'classnames';

import PageContainer from './PageContainer';
import PageHeader from './PageHeader';

const styles = theme => {
    const unit = theme.spacing();
    return {
        body: {
            padding: unit * 2,
            '&:last-child': {
                marginBottom: 0,
                paddingBottom: `${unit * 2}px`,
            },
        },
        centerContent: {
            textAlign: 'center',
        },
    };
};

const PaperContainer = ({
    title,
    subtitle,
    info,
    noBodyBorder,
    headerOut,
    secondary,
    className,
    children,
    center,
}) => {
    const header = (
        <PageHeader
            title={title}
            subtitle={subtitle}
            outside={headerOut}
            secondary={secondary}
        >
            {info}
        </PageHeader>
    );
    return (
        <PageContainer className={className}>
            {headerOut && header}
            <Paper elevation={1}>
                {!headerOut && header}
                {noBodyBorder ? (
                    children
                ) : (
                    <PaperContainer.Body center={center}>
                        {children}
                    </PaperContainer.Body>
                )}
            </Paper>
        </PageContainer>
    );
};

PaperContainer.Body = withStyles(styles)(({ classes, children, center }) => (
    <div
        className={classNames({
            [classes.body]: true,
            [classes.centerContent]: center,
        })}
    >
        {children}
    </div>
));

PaperContainer.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    info: PropTypes.node,
    noBodyBorder: PropTypes.bool,
    headerUp: PropTypes.bool,
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
};

PaperContainer.defaultProps = {
    subtitle: '',
    noBodyBorder: false,
    headerUp: false,
};

export default withStyles(styles)(PaperContainer);
